import { useState, useEffect } from "react";
import _ from "lodash";

type Props = {
  __map__?: any;
  __amapui__?: any;
  keyword: string;
  onSearched: Function;
  userCurrentPosition?: any;
};

const doSearchDebounce = _.debounce((onSearched, autocomplete, keyword) => {
  autocomplete.search(keyword, function (status, result) {
    if (status === "complete") {
      if (result?.count > 0 && result?.tips) {
        onSearched(result?.tips, keyword);
      } else {
        onSearched([], keyword);
      }
    }
  });
}, 300);

export default function AutoComplete(props: Props) {
  const { __map__, keyword, onSearched } = props;
  const [autocomplete, setAutocomplete] = useState<any>(null);

  useEffect(() => {
    __map__.plugin(["AMap.Autocomplete", "AMap.PlaceSearch"], function () {
      setAutocomplete(
        new AMap.Autocomplete({
          city: "全国",
        }),
      );
    });
  }, [__map__]);

  useEffect(() => {
    if (autocomplete && keyword) {
      doSearchDebounce(onSearched, autocomplete, keyword);
    }
  }, [keyword, autocomplete, onSearched]);

  return null;
}
